import { useMemo } from 'react';
import { generatePath } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import type { ReportConfigAllocationCombination } from 'src/types/reportConfig';
import { apiPaths } from 'src/services/api/apiPaths';
import HttpService from 'src/services/api/http';
import { useUserContext } from 'src/components/app/context/UserContext';

export const useReportConfigAllocationCombinationQuery = (
  moduleId?: number | null,
  enabled: boolean = true,
) => {
  const { currentSurvey } = useUserContext();
  const surveyId = currentSurvey?.id;

  const path = apiPaths.REPORT_CONFIG.COMBINATION;
  const endpoint = useMemo(
    () =>
      generatePath(path, {
        moduleId: Number(moduleId),
        surveyId: Number(surveyId),
      }),
    [path, moduleId, surveyId],
  );

  const { data, isFetching, isLoading, isFetched } =
    useQuery<ReportConfigAllocationCombination>({
      queryKey: [endpoint],
      enabled: enabled && !!surveyId && !!moduleId,
      queryFn: ({ signal }) =>
        HttpService.get(endpoint, {}, true, { signal })
          .then((data) => Promise.resolve(data.data))
          .catch(({ response }) => Promise.reject(response.status)),
    });
  const loading = isFetching || isLoading;
  const fetched = isFetched;

  return { data, loading, fetched };
};
